export default "__VITE_ASSET__DtfAtLZ8__"